// extracted by mini-css-extract-plugin
export default {"link":"BaseLink_link__fel2I","button":"BaseLink_button__FWCWb","s":"BaseLink_s__prv59","m":"BaseLink_m__5JPvo"};